









































































import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { ICompanyCreateRequest } from "@/types/company";

@Component({})
export default class extends Vue {
  @Action("company/create")
  public create!: (params: ICompanyCreateRequest) => boolean;

  public show_password_conf = false;

  public params: ICompanyCreateRequest = {
    name: "",
    display_name: "",
    email: "",
    tel: "",
    address: "",
  };

  private async submit() {
    return await this.create(this.params);
  }
}
